import { wrapRetry } from '@perpay-web/utils/importUtils';

export const importPayrollConnectionSuccess = () =>
    wrapRetry(
        () =>
            import(
                /* webpackChunkName: "PayrollConnectionSuccessScreen" */
                '@perpay-web/fintech/components/screens/PayrollConnectionSuccessScreen/PayrollConnectionSuccessScreen'
            ),
    );
